import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class LoaderRef {
  readonly text: string;

  constructor(private loaderService: LoaderService, text: string) {
    this.text = text;
  }

  close(): void {
    this.loaderService.close(this);
  }
}

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  loaderTexts$: Observable<string[]>;
  showLoader$: Observable<boolean>;

  private loaders$ = new BehaviorSubject<LoaderRef[]>([]);

  constructor() {
    this.showLoader$ = this.loaders$.pipe(map((n) => n.length > 0));
    this.loaderTexts$ = this.loaders$.pipe(
      map((loaders) => loaders.map((l) => l.text))
    );
  }

  open(loaderText?: string): LoaderRef {
    const loader = new LoaderRef(this, loaderText ?? '');

    this.appendLoader(loader);
    return loader;
  }

  close(loaderRef: LoaderRef): void {
    this.removeLoader(loaderRef);
  }

  private appendLoader(loader: LoaderRef): void {
    const activatedLoaders = this.getActivatedLoaders();

    this.loaders$.next([...activatedLoaders, loader]);
  }

  private removeLoader(loaderRef: LoaderRef): void {
    const activatedLoaders = this.getActivatedLoaders();

    const loaderIndex = activatedLoaders.findIndex((l) => l === loaderRef);

    if (loaderIndex === -1) {
      return;
    }

    activatedLoaders.splice(loaderIndex, 1);

    this.loaders$.next(activatedLoaders);
  }

  private getActivatedLoaders(): LoaderRef[] {
    return this.loaders$.getValue();
  }
}
